import { FastQuestionTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/employeeProfile.chat.translation.en.ts';

export const employeeProfileChatFastQuestionsOwnerTranslation: FastQuestionTranslation = {
  fastQuestionButtons: {
    question1: 'My development',
    question2: 'Project fit',
    question3: 'Competencies for development',
    question4: 'Career path',
    question5: 'Development goals',
    question6: 'Educational materials',
    question7: 'Action plan',
  },
  fastQuestionTexts: {
    question1: 'How can I develop in my current position?',
    question2: 'In which projects could I best utilize my skills?',
    question3: 'What competencies should I prioritize for development?',
    question4: 'What steps do I need to take to advance to a higher position?',
    question5: 'What development goals should I set for the upcoming months?',
    question6: 'What courses, books, or training can support my development?',
    question7: 'How can I create a specific professional development plan?',
  },
};
